import React from 'react';
import { Redirect, useParams } from 'react-router-dom';

const AddGiftcard: React.FC = () => {
  const { token } = useParams();
  return <Redirect to={`/?giftcardToken=${token}`} />;
};

export default AddGiftcard;
